export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/404w-af33af52a40e82e328f73a558bbfb0b1.webp";